export const articlesBody = [
  {
    id: "body-1",
    title: "私密部位的日常清洁与护理",
    summary:
      "正确的清洁方式其实比想象的更简单。过度的护理反而可能带来问题，本文带你了解温和、科学的日常做法。",
    cover:
      "https://readdy.ai/api/search-image?query=clean%20minimal%20abstract%20illustration%20of%20soft%20teal%20water%20ripples%20and%20warm%20cream%20tones%2C%20fresh%20wellness%20editorial%20style&width=800&height=600&seq=body-01&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-26",
    readCount: 8120,
    tags: ["清洁", "护理"],
    sections: [
      {
        heading: "温和清洁就足够",
        paragraphs: [
          "身体本身具有自我调节能力，日常用清水或温和的清洁产品即可，不需要用力或频繁清洗。",
          "过度清洁反而可能破坏天然的保护屏障。",
        ],
      },
      {
        heading: "选对产品很重要",
        paragraphs: [
          "尽量选择成分简单、刺激性小的产品，避免香味浓烈或强效杀菌的类型。",
        ],
      },
      {
        heading: "出现不适怎么办",
        paragraphs: [
          "如果持续瘙痒、异味或疼痛，及时咨询专业医生，不要自行用偏方处理。",
        ],
      },
    ],
  },
  {
    id: "body-2",
    title: "自慰时的安全与卫生注意事项",
    summary:
      "安全与卫生能让体验更安心。本文列出几条容易被忽视但很实用的建议，帮你更好地照顾自己。",
    cover:
      "https://readdy.ai/api/search-image?query=safe%20and%20clean%20minimal%20abstract%20illustration%20with%20teal%20and%20sage%20curves%2C%20gentle%20wellness%20editorial%20style&width=800&height=600&seq=body-02&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-23",
    readCount: 6480,
    tags: ["安全", "卫生"],
    sections: [
      {
        heading: "保持清洁与适度",
        paragraphs: [
          "开始前洗手、修剪指甲、保持动作温和，能有效减少皮肤损伤与不适。",
        ],
      },
      {
        heading: "善用润滑",
        paragraphs: [
          "合适的润滑剂可以减少摩擦带来的刺激，让体验更舒适、更安全。",
        ],
      },
      {
        heading: "留意身体的反馈",
        paragraphs: [
          "一旦出现持续疼痛、出血或不适，应暂停并寻求专业建议。",
        ],
      },
    ],
  },
  {
    id: "body-3",
    title: "认识身体：了解自己的生理结构",
    summary:
      "了解身体是健康的第一步。本文用平和、科学的方式介绍基本生理知识，帮助你建立清晰的认知。",
    cover:
      "https://readdy.ai/api/search-image?query=educational%20minimal%20abstract%20illustration%20in%20soft%20teal%20and%20warm%20beige%20tones%2C%20calm%20anatomy%20wellness%20editorial%20style&width=800&height=600&seq=body-03&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-20",
    readCount: 4360,
    tags: ["生理", "科普"],
    sections: [
      {
        heading: "身体值得被了解",
        paragraphs: [
          "清楚的生理知识能帮助你更好地理解身体的反应，减少不必要的担心。",
        ],
      },
      {
        heading: "用平常心对待",
        paragraphs: [
          "身体的存在是自然的，了解它、尊重它，是自我照顾的重要部分。",
        ],
      },
    ],
  },
  {
    id: "body-4",
    title: "润滑剂的选择与正确使用",
    summary:
      "润滑剂能显著提升舒适度与安全性。市面上种类繁多，本文帮你厘清区别，选择适合自己的那一款。",
    cover:
      "https://readdy.ai/api/search-image?query=smooth%20minimal%20abstract%20illustration%20of%20glossy%20teal%20droplets%20and%20warm%20amber%20highlights%2C%20clean%20wellness%20editorial%20style&width=800&height=600&seq=body-04&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-17",
    readCount: 3980,
    tags: ["润滑", "实用"],
    sections: [
      {
        heading: "常见的几种类型",
        paragraphs: [
          "水基产品易清洗、兼容性好；硅基产品更持久；油基产品需注意与某些用品的兼容性。",
          "根据使用场景选择，体验会更好。",
        ],
      },
      {
        heading: "使用小贴士",
        paragraphs: [
          "先少量试用，确认无过敏反应；注意保质期与清洁保存。",
        ],
      },
    ],
  },
  {
    id: "body-5",
    title: "常见私密不适信号与应对",
    summary:
      "身体会用信号和你沟通。了解哪些是正常波动，哪些需要就医，能帮助你及时、正确地处理。",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20minimal%20abstract%20illustration%20of%20calm%20teal%20signals%20and%20soft%20peach%20tones%2C%20health%20awareness%20wellness%20editorial%20style&width=800&height=600&seq=body-05&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-14",
    readCount: 5120,
    tags: ["警示", "就医"],
    sections: [
      {
        heading: "哪些变化通常是正常的",
        paragraphs: [
          "随周期、作息和压力出现的轻微变化，多数属于正常波动。",
        ],
      },
      {
        heading: "哪些情况建议就医",
        paragraphs: [
          "持续疼痛、异常出血、明显异味或长时间不缓解的不适，建议及早就诊。",
          "及时就医是对身体负责，不必感到尴尬。",
        ],
      },
    ],
  },
  {
    id: "body-6",
    title: "经期、身体变化与自我照顾",
    summary:
      "月经周期会给许多方面带来影响，包括情绪与身体感受。了解这些变化，能帮助你更从容地照顾自己。",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20warm%20minimal%20abstract%20illustration%20of%20a%20gentle%20cycle%20in%20teal%20and%20terracotta%20tones%2C%20wellness%20editorial%20style&width=800&height=600&seq=body-06&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-11",
    readCount: 3640,
    tags: ["周期", "照顾"],
    sections: [
      {
        heading: "周期中的起伏",
        paragraphs: [
          "激素水平在周期中变化，可能带来情绪与身体感受的波动，这些都是常见的。",
        ],
      },
      {
        heading: "给自己多一点温柔",
        paragraphs: [
          "在状态起伏时，适当休息、注意保暖和营养，是很好的自我照顾方式。",
        ],
      },
    ],
  },
  {
    id: "body-7",
    title: "适度运动如何促进身体与性健康",
    summary:
      "规律运动不仅改善体能，也与情绪和整体健康密切相关。本文聊聊如何用简单的方式动起来。",
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20minimal%20abstract%20illustration%20of%20flowing%20teal%20and%20orange%20waves%2C%20active%20wellness%20editorial%20style&width=800&height=600&seq=body-07&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-08",
    readCount: 4210,
    tags: ["运动", "健康"],
    sections: [
      {
        heading: "运动带来的好处",
        paragraphs: [
          "规律运动有助于改善血液循环、缓解压力、提升睡眠质量，这些都与整体健康息息相关。",
        ],
      },
      {
        heading: "从可以坚持开始",
        paragraphs: [
          "选择自己喜欢的项目，从每天十几分钟开始，比追求强度更重要。",
        ],
      },
    ],
  },
  {
    id: "body-8",
    title: "睡眠、饮食与性健康的关系",
    summary:
      "身体的各项功能彼此关联。良好的睡眠与均衡的饮食，其实是支持身心健康的坚实基础。",
    cover:
      "https://readdy.ai/api/search-image?query=balanced%20minimal%20abstract%20illustration%20of%20teal%20and%20warm%20sand%20shapes%20representing%20balance%2C%20wellness%20editorial%20style&width=800&height=600&seq=body-08&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-05",
    readCount: 3450,
    tags: ["睡眠", "饮食"],
    sections: [
      {
        heading: "基础决定状态",
        paragraphs: [
          "长期睡眠不足与饮食不均衡会影响情绪、精力和身体状态，也会间接影响整体感受。",
        ],
      },
      {
        heading: "从小习惯改起",
        paragraphs: [
          "固定作息、多喝水、多吃天然食物，是简单又有效的方向。",
        ],
      },
    ],
  },
  {
    id: "body-9",
    title: "何时应该咨询专业医生",
    summary:
      "并非所有问题都需要看医生，但也有些情况不该拖延。本文帮你判断什么时候寻求专业帮助是明智的。",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20professional%20minimal%20abstract%20illustration%20in%20teal%20and%20soft%20peach%2C%20medical%20wellness%20editorial%20style&width=800&height=600&seq=body-09&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-09-02",
    readCount: 4090,
    tags: ["就医", "建议"],
    sections: [
      {
        heading: "值得就医的信号",
        paragraphs: [
          "持续疼痛、异常出血、明显功能改变，或长期存在的困扰，都建议进行专业评估。",
        ],
      },
      {
        heading: "看医生并不可怕",
        paragraphs: [
          "医生每天都会面对各种健康问题，你的困扰对他们而言是正常的工作内容。",
        ],
      },
    ],
  },
  {
    id: "body-10",
    title: "身体自我检查的简单方法",
    summary:
      "定期了解自己的身体状态，是很好的健康习惯。本文介绍几个简单、无压力的自我观察方法。",
    cover:
      "https://readdy.ai/api/search-image?query=careful%20minimal%20abstract%20illustration%20of%20soft%20teal%20hands%20shape%20with%20warm%20tones%2C%20self%20care%20wellness%20editorial%20style&width=800&height=600&seq=body-10&orientation=landscape",
    categoryId: "body",
    author: "编辑部",
    date: "2026-08-30",
    readCount: 2760,
    tags: ["自查", "习惯"],
    sections: [
      {
        heading: "了解自己的“常态”",
        paragraphs: [
          "每个人都有自己的基础状态，了解它，才更容易察觉异常。",
        ],
      },
      {
        heading: "养成记录的习惯",
        paragraphs: [
          "简单记录周期与身体感受，能在就医时为医生提供有价值的参考。",
        ],
      },
    ],
  },
];